export default "__VITE_ASSET__CKIHznfw__"